export default function isLocal(host: string): boolean {
  let [hostName] = host.toLowerCase().split(':');
  return hostName === 'localhost' || hostName === '127.0.0.1';
}
